import React from 'react';
import ReactLoading from 'react-loading';
import PaymentMethodForm from '../PaymentMethodForm/PaymentMethodForm';
import LocalizedMessage from 'react-l10n';

function CheckoutPaymentMethods(props) {
    const {
        fieldStatus,
        memberType,
        disableAssignedSupplierNumber,
        isLoading,
        availablePaymentMethods,
        checkoutData,
    } = props;

    console.log("Checkout Data ================++> ", checkoutData);


    let creditCardContent = null;
    let showCreditCardFields = true;

    if (checkoutData.HasSourceOrder) {
        if (checkoutData.SourceOrder.PaymentMethod === 'stripe' && !checkoutData.IsTotalGreaterThanSourceOrder && !checkoutData.IsPaymentCaptureFailed && !checkoutData.IsBackOrder) {
            creditCardContent = (
                <div className="notice notice--icon notice--big">
                    <i className="icon icon-warning"></i>
                    <span className="heading heading--lv5">
                        <LocalizedMessage id={'PAYMENT_FORM.CREDIT_CARD.LOCKED_AMOUNT'} />
                    </span>
                </div>
            );

            showCreditCardFields = false;
        }
        else {
            creditCardContent = (
                <div className="notice notice--icon notice--big notice--alert">
                    <i className="icon icon-warning"></i>
                    <span className="heading heading--lv5">
                        <LocalizedMessage id={'PAYMENT_FORM.CREDIT_CARD.REQUIRE_CREDIT_CARD'} />
                    </span>
                </div>
            );
        }
    }

    const bankTransferContent = (
        <div className='notice'>
            <div className='vspace vspace--small'>
                <div className='text-box text-box--small'>
                    <p>
                        <LocalizedMessage
                            id={
                                'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_BANK_TRANSFER'
                            }
                        />
                    </p>
                </div>
            </div>
        </div>
    );

    const chargeAccountContent = (
        <React.Fragment>
            <h5 className='heading heading--lv5'>
                <LocalizedMessage id={'PAYMENT_FORM.CHARGE_ACCOUNT.HEADING'} />
            </h5>
            {disableAssignedSupplierNumber == false && (
                <p>
                    {memberType == 'wholesaler' && (
                        <LocalizedMessage
                            id={
                                'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_WHOLESALER'
                            }
                        />
                    )}
                    {(memberType == 'reseller' ||
                        memberType == 'parent-reseller') && (
                            <LocalizedMessage
                                id={'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_RESELLER'}
                            />
                        )}
                    {memberType == 'retail-customer' && (
                        <LocalizedMessage
                            id={'PAYMENT_FORM.CHARGE_ACCOUNT.CONTENT_CUSTOMER'}
                        />
                    )}
                </p>
            )}
        </React.Fragment>
    );

    return (
        <React.Fragment>
            <div className="vspace" style={{ position: 'relative' }}>
                {isLoading === true && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 10,
                            background: 'rgba(255,255,255,0.75)',
                            display: 'flex',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <ReactLoading
                            type='spin'
                            className='button__spinner'
                            color='black'
                            height={20}
                            width={20}
                        />
                    </div>
                )}
                <PaymentMethodForm
                    {...props}
                    {...availablePaymentMethods}
                    showCreditCardFields={showCreditCardFields}
                    fieldStatus={fieldStatus}
                    showCreditCardBillingAddressFields={false}
                    creditCardContent={creditCardContent}
                    bankTransferContent={bankTransferContent}
                    chargeAccountContent={chargeAccountContent}
                />
            </div>
        </React.Fragment>
    );
}

export default CheckoutPaymentMethods;
